import { Phone, MapPin } from "@phosphor-icons/react";
import { CVC_LOGO } from "./constants";

export default function Footer() {
  return (
    <footer className="relative bg-cvc-navy-deep text-cvc-cream/85 py-14">
      <a
        href="https://trustedbusinessawards.com/verify?url=utahbusinessconsultant.com"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-trusted-business-award"
        aria-label="Trusted Business Awards — Verified"
        className="absolute top-0 right-0 z-10 pointer-events-auto"
      >
        <img
          src="https://trustedbusinessawards.com/public/Awards_Logos/Award_Top_Gold.png"
          alt="Trusted Business Awards — Verified"
          width="150"
          className="drop-shadow-lg block"
        />
      </a>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid md:grid-cols-3 gap-10">
        <div>
          <img src={CVC_LOGO} alt="Cache Valley Consulting" className="h-12 w-auto bg-cvc-cream rounded-md p-1.5" />
          <p className="font-body text-sm text-cvc-cream/70 mt-4 leading-relaxed max-w-xs">
            Cache Valley Consulting is a DBA of Epic Enterprises LLC — serving Logan, UT and Cache Valley since 2018.
          </p>
        </div>
        <div>
          <p className="font-heading text-xl text-cvc-cream">Contact</p>
          <div className="mt-4 space-y-2 font-body text-sm text-cvc-cream/80">
            <p className="flex items-start gap-2"><Phone size={16} weight="duotone" className="mt-1 shrink-0" /> 435-535-7000</p>
            <p className="flex items-start gap-2"><MapPin size={16} weight="duotone" className="mt-1 shrink-0" /> P.O. Box 192, Hyde Park, UT 84318</p>
          </div>
        </div>
        <div>
          <p className="font-heading text-xl text-cvc-cream">Family of services</p>
          <ul className="mt-4 space-y-2 font-body text-sm text-cvc-cream/80">
            <li>Epic Enterprises Consulting <span className="text-cvc-cream/50">(parent)</span></li>
            <li>Cache Valley Consulting <span className="text-cvc-cream/50">(local, Logan)</span></li>
            <li>
              <a
                href="https://www.scaledeasy.com/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-scaledeasy-link"
                className="hover:text-cvc-cream underline-offset-4 hover:underline"
              >
                ScaledEasy.com
              </a>{" "}
              <span className="text-cvc-cream/50">(national, phone-based)</span>
            </li>
          </ul>
          <a href="/admin/login" data-testid="footer-admin-link" className="inline-block mt-6 text-xs font-body text-cvc-cream/40 hover:text-cvc-cream/80 underline underline-offset-4">
            Admin
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-10 mt-10 border-t border-cvc-cream/15 flex flex-wrap justify-between gap-3 font-body text-xs text-cvc-cream/55">
        <span>© {new Date().getFullYear()} Epic Enterprises LLC dba Cache Valley Consulting™. All rights reserved.</span>
        <span>Best of Northern Utah 2026 — Business Consulting</span>
      </div>
    </footer>
  );
}
